import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class CommentService extends RLBaseService {
    static $inject = ["$resource"];
    constructor(private $resource: ng.resource.IResourceService) {
        super($resource);
    }

    createComment(comment: Models.IComment) {
        return this.toRLService<{ id: number }>("/api/Comment/Create").post(comment).$promise;
    }

    updateComment(comment: Models.IComment) {
        return this.toRLService<void>("/api/Comment/Update").post(comment).$promise;
    }

    getComments(entityID: string) {
        return this.toRLService<Models.ICommentResponse>("/api/Comment/Get").get({ entityID: entityID }).$promise;
    }

    deleteComment(comment: Models.IComment) {
        return this.toRLService<void>("/api/Comment/Delete").delete({ commentID: comment.id }).$promise;
    }
}